const icon = state => state.icon;
const contact_icon = state => state.contact_icon;
const clients = state => state.clients;
const client = state => state.client;
const clientContacts = state => state.clientContacts;
const clientContact = state => state.clientContact;
const site = state => state.site;
const sites = state => state.sites;
const building = state => state.building;
const buildings = state => state.buildings;
const plant = state => state.plant;
const plants = state => state.plants;
const plantTypes = state => state.plantTypes;
const consultant = state => state.consultant;
const consultants = state => state.consultants;

export default {
  icon,
  contact_icon,
  clients,
  client,
  clientContacts,
  clientContact,
  sites,
  site,
  buildings,
  building,
  plants,
  plant,
  plantTypes,
  consultant,
  consultants
};
